'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeProductForm = require('@shopify/theme-product-form');

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _themeA11y = require('@shopify/theme-a11y');

require('van11y-accessible-tab-panel-aria');

require('van11y-accessible-accordion-aria');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = {
  hide: 'hide'
}; /**
    * Product Template Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Product template.
    *
    * @namespace product
    */

var keyboardKeys = {
  ENTER: 13
};

var selectors = {
  submitButton: '[data-submit-button]',
  submitButtonText: '[data-submit-button-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  priceWrapper: '[data-price-wrapper]',
  imageWrapper: '[data-product-image-wrapper]',
  visibleImageWrapper: '[data-product-image-wrapper]:not(.' + classes.hide + ')',
  imageWrapperById: function imageWrapperById(id) {
    return selectors.imageWrapper + '[data-image-id=\'' + id + '\']';
  },
  productForm: '[data-product-form]',
  productPrice: '[data-product-price]',
  thumbnail: '[data-product-single-thumbnail]',
  thumbnailById: function thumbnailById(id) {
    return '[data-thumbnail-id=\'' + id + '\']';
  },
  thumbnailActive: '[data-product-single-thumbnail][aria-current]'
};

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var productFormElement, qtySelectors, i, awardDropdown, awardDropdownContent, productDataEl, productReviews, productAwards, reviewsHtml, reviewsSlider, resize, productReviewsEl, html, awardsHtml, awardsAccordionContainer, awardsAccordionEl;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              productFormElement = document.querySelector(selectors.productForm);
              qtySelectors = _this.container.querySelectorAll('[data-quantity-selector]');

              if (!productFormElement) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return _this.getProductJson(productFormElement.dataset.productHandle);

            case 5:
              _this.product = _context.sent;

              _this.productForm = new _themeProductForm.ProductForm(productFormElement, _this.product, {
                onOptionChange: _this.onFormOptionChange.bind(_this)
              });

            case 7:

              _this.onThumbnailClick = _this.onThumbnailClick.bind(_this);
              _this.onThumbnailKeyup = _this.onThumbnailKeyup.bind(_this);

              _this.container.addEventListener('click', _this.onThumbnailClick);
              _this.container.addEventListener('keyup', _this.onThumbnailKeyup);

              if (qtySelectors.length) {
                for (i = 0; i < qtySelectors.length; i++) {
                  qtySelectors[i].addEventListener('click', function () {
                    _this.handleQuantitySelector(event);
                  });
                }
              }

              if (window.innerWidth > 992) {
                awardDropdown = document.querySelector('.js-accordion__header');
                awardDropdownContent = document.querySelector('.js-accordion__panel');


                if (awardDropdown) {
                  awardDropdown.setAttribute('aria-expanded', true);
                }

                if (awardDropdownContent) {
                  awardDropdownContent.removeAttribute('aria-hidden');
                }
              }

              productDataEl = document.querySelector('[data-product-data]');
              productReviews = void 0;
              productAwards = void 0;


              if (productDataEl) {
                productReviews = JSON.parse(JSON.parse(productDataEl.innerHTML).reviews);
                productAwards = JSON.parse(JSON.parse(productDataEl.innerHTML).awards);
              }

              if (productReviews && productReviews.length > 0) {
                reviewsHtml = '';

                productReviews.forEach(function (review) {
                  reviewsHtml += '\n          <div class="product-reviews__slide">\n            <div class="product-reviews__review">\n              <svg xmlns="http://www.w3.org/2000/svg" width="62.86" height="59.73" viewBox="0 0 62.86 59.73" class="icon icon-quote"><path d="M39,20.69a32.47,32.47,0,0,0-3.38.93C25,26,20.33,34.8,18.19,45.28,16,56.13,16.77,67.19,16.65,78.17c0,1.59.71,2.25,2.28,2.25q10.5,0,21,0c1.46,0,2.14-.6,2.13-2.09q0-10.62,0-21.24c0-1.47-.56-2.14-2.07-2.1-2.16.05-4.33,0-6.5,0-1.8,0-2.67-.73-2.51-2.53.35-4.15.27-8.4,1.24-12.39.8-3.29,2.2-6.93,4.51-9.22C39.93,27.68,38.94,24.47,39,20.69Z" transform="translate(-16.6 -20.69)" fill="#fff"></path><path d="M39,20.69c0,3.78,1,7-2.23,10.16-2.31,2.29-3.71,5.93-4.51,9.22-1,4-.89,8.24-1.24,12.39-.16,1.8.71,2.58,2.51,2.53,2.17-.05,4.34,0,6.5,0,1.51,0,2.07.63,2.07,2.1q-.06,10.62,0,21.24c0,1.49-.67,2.1-2.13,2.09q-10.5,0-21,0c-1.57,0-2.29-.66-2.28-2.25.12-11-.68-22,1.54-32.89C20.33,34.8,25,26,35.59,21.62A32.47,32.47,0,0,1,39,20.69Z" transform="translate(-16.6 -20.69)"></path><path d="M76.37,20.69a31.79,31.79,0,0,0-3.38.93C62.4,26,57.73,34.8,55.58,45.28c-2.22,10.85-1.42,21.91-1.53,32.89,0,1.59.71,2.25,2.27,2.25q10.5,0,21,0c1.46,0,2.13-.6,2.13-2.09q0-10.62,0-21.24c0-1.47-.56-2.14-2.06-2.1-2.17.05-4.34,0-6.5,0-1.8,0-2.67-.73-2.52-2.53.36-4.15.28-8.4,1.25-12.39.79-3.29,2.19-6.93,4.5-9.22C77.33,27.68,76.34,24.47,76.37,20.69Z" transform="translate(-16.6 -20.69)" fill="#fff"></path><path d="M76.37,20.69c0,3.78,1,7-2.24,10.16-2.31,2.29-3.71,5.93-4.5,9.22-1,4-.89,8.24-1.25,12.39-.15,1.8.72,2.58,2.52,2.53,2.16-.05,4.33,0,6.5,0,1.5,0,2.07.63,2.06,2.1q0,10.62,0,21.24c0,1.49-.67,2.1-2.13,2.09q-10.5,0-21,0c-1.56,0-2.29-.66-2.27-2.25.11-11-.69-22,1.53-32.89C57.73,34.8,62.4,26,73,21.62A31.79,31.79,0,0,1,76.37,20.69Z" transform="translate(-16.6 -20.69)"></path></svg>\n              ' + (review.body ? '<p class="product-review__quote">' + review.body + '</p>' : '') + '\n              <div class="product-review__meta">\n              ' + (review.reviewer ? '<p class="product-review__author">- ' + review.reviewer + '</p>' : '') + '\n              ' + (review.name || review.publication ? '<p class="product-review__author-credentials">' + (review.name ? review.name : review.publication) + '</p>' : '') + '\n              ' + (review.date ? '<p class="product-review__date">' + review.date + '</p>' : '') + '\n              ' + (review.points ? '<div class="points-badge"><span>' + review.points + '</span>Points</div>' : '') + '\n              </div>\n            </div>\n          </div>\n        ';
                });

                reviewsSlider = document.querySelector('.product-reviews__slider');

                reviewsSlider.setAttribute('data-slides', productReviews.length);
                reviewsSlider.innerHTML = reviewsHtml;

                _this.slider = null;
                if (reviewsSlider) {
                  _this.slider = new _flickity2.default(reviewsSlider, {
                    draggable: true,
                    freeScroll: false,
                    prevNextButtons: true,
                    autoPlay: false,
                    pageDots: false,
                    setGallerySize: true,
                    cellAlign: 'left',
                    watchCSS: true,
                    groupCells: true,
                    contain: true,
                    arrowShape: 'M24.21,47.42,70.33,2.11a3.89,3.89,0,0,1,5.46,0,3.76,3.76,0,0,1,0,5.39L32.42,50.11,75.79,92.72a3.77,3.77,0,0,1,0,5.39,3.9,3.9,0,0,1-5.46,0L24.21,52.81a3.82,3.82,0,0,1-1.13-2.7A3.78,3.78,0,0,1,24.21,47.42Z'
                  });

                  // add this code
                  _flickity2.default.prototype._createResizeClass = function () {
                    this.element.classList.add('flickity-resize');
                  };

                  _flickity2.default.createMethods.push('_createResizeClass');

                  resize = _flickity2.default.prototype.resize;

                  _flickity2.default.prototype.resize = function () {
                    this.element.classList.remove('flickity-resize');
                    resize.call(this);
                    this.element.classList.add('flickity-resize');
                  };
                }
              } else {
                productReviewsEl = document.querySelector('.product-reviews');


                if (productReviewsEl) {
                  productReviewsEl.classList.add('hide');
                }
              }

              if (productAwards && productAwards.length > 0) {
                html = '';
                awardsHtml = '';
                awardsAccordionContainer = document.querySelector('.js-accordion__panel');

                productAwards.forEach(function (award) {
                  awardsHtml += '<li>\n            <div>\n              ' + (award.awardType === 'trophy' ? '<svg\n                    xmlns="http://www.w3.org/2000/svg"\n                    viewBox="0 0 512 512"\n                    class="icon icon-trophy"\n                  >\n                    <path\n                      d="M497,37H431.3c.2-7.3.4-14.6.4-22a15,15,0,0,0-15-15H95.3a15,15,0,0,0-15,15c0,7.4.1,14.7.4,22H15A15,15,0,0,0,0,52c0,67.2,17.6,130.6,49.5,178.6C81,278,123,305.2,168.4,307.8a156.15,156.15,0,0,0,32.5,27.3v66.7H175.7A55.31,55.31,0,0,0,120.5,457v25h-1.1a15,15,0,1,0,0,30H392.5a15,15,0,0,0,0-30h-1.1V456.8a55.25,55.25,0,0,0-55.2-55.2H311V335a156.15,156.15,0,0,0,32.5-27.3c45.4-2.6,87.4-29.8,118.9-77.2C494.4,182.6,512,119.2,512,52A15,15,0,0,0,497,37ZM74.4,213.9C48.1,174.4,32.7,122.6,30.3,67H82.4c5.4,68.5,21.5,131.7,46.6,182,4,8,8.2,15.6,12.5,22.7C116.6,262.2,93.5,242.5,74.4,213.9ZM361.5,456.8V482h-211V456.8a25.22,25.22,0,0,1,25.2-25.2H336.4A25.33,25.33,0,0,1,361.5,456.8Zm-80.3-55.1H230.9V348a97.87,97.87,0,0,0,50.4,0v53.7Zm9.3-89.4a11.4,11.4,0,0,0-1.9,1,70,70,0,0,1-65,0,12.44,12.44,0,0,0-2-1c-11.8-6.2-23.1-15.6-33.9-27.9a13.68,13.68,0,0,0-1.9-2.2c-10.7-12.7-20.7-28.3-29.9-46.6C128.3,180.5,112.4,108,110.6,30.1h291c-1.8,77.9-17.7,150.4-45.3,205.5-9.2,18.4-19.2,34-29.9,46.6a13,13,0,0,0-1.9,2.2C313.6,296.7,302.2,306.1,290.5,312.3Zm147.1-98.4c-19,28.6-42.1,48.3-67.1,57.7,4.3-7.1,8.5-14.7,12.5-22.7,25.1-50.2,41.2-113.5,46.6-182h52.1C479.3,122.6,463.9,174.4,437.6,213.9Z"\n                      fill="#997c00"\n                    />\n                  </svg>' : '<svg\n                    xmlns="http://www.w3.org/2000/svg"\n                    viewBox="0 0 452.11 512"\n                    class="icon icon-medal"\n                  >\n                    <path\n                      d="M336,160.8a10,10,0,0,0-8.1-6.8l-43.5-6.3-19.5-39.4a10.12,10.12,0,0,0-9-5.6h0a10.12,10.12,0,0,0-9,5.6l-19.4,39.4L184,154a10,10,0,0,0-5.6,17l31.5,30.7L202.5,245a10.1,10.1,0,0,0,4,9.8,9.67,9.67,0,0,0,5.9,1.9,11.16,11.16,0,0,0,4.7-1.1L256,235.1l38.9,20.4a9.75,9.75,0,0,0,10.5-.8,10,10,0,0,0,4-9.8L302,201.6l31.5-30.7A9.67,9.67,0,0,0,336,160.8Zm-51.7,30.3a10.1,10.1,0,0,0-2.9,8.9l4.9,28.5L260.7,215a10.17,10.17,0,0,0-9.3,0l-25.6,13.5,4.9-28.5a9.91,9.91,0,0,0-2.9-8.9L207,170.9l28.7-4.2a9.77,9.77,0,0,0,7.5-5.5l12.8-26,12.8,26a10.11,10.11,0,0,0,7.5,5.5l28.7,4.2Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                    <path\n                      d="M480.7,439.4,398,295.6A181.13,181.13,0,0,0,438,182C438,81.6,356.4,0,256,0S74,81.6,74,182a181.64,181.64,0,0,0,39.9,113.6L31.3,439.4a10,10,0,0,0,10,14.9l64.5-8.7,24.8,60.2a10.12,10.12,0,0,0,8.6,6.2h.7a10,10,0,0,0,8.7-5L232,362.5v-.1a191.26,191.26,0,0,0,24.1,1.6,174.22,174.22,0,0,0,24.1-1.6v.1L363.6,507a10,10,0,0,0,8.7,5h.7a10.07,10.07,0,0,0,8.6-6.2l24.8-60.2,64.5,8.7a10,10,0,0,0,9.6-4.3A10.34,10.34,0,0,0,480.7,439.4Zm-339.4,40-18-43.8,16.2-26.4a10,10,0,1,0-17.1-10.5L106,425.4l-47.3,6.4L128,311.2a182.49,182.49,0,0,0,83.1,47.2ZM256,344c-89.3,0-162-72.7-162-162S166.7,20,256,20,418,92.7,418,182,345.3,344,256,344Zm150,81.4-16.3-26.7a10,10,0,0,0-17.1,10.5l16.2,26.4-18,43.8L301,358.4a181.09,181.09,0,0,0,83.1-47.2l69.3,120.5Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                    <path\n                      d="M256,52a131.27,131.27,0,0,0-63.7,16.6A10,10,0,0,0,202.1,86,110,110,0,0,1,366,181.9a108.43,108.43,0,0,1-10.7,47.3,9.9,9.9,0,0,0,4.7,13.3,9.65,9.65,0,0,0,4.3,1,10,10,0,0,0,9-5.7,128.38,128.38,0,0,0,12.6-55.9C386,110.3,327.7,52,256,52Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                    <path\n                      d="M349,258.4a10,10,0,0,0-14.1.2l-.2.2a9.95,9.95,0,0,0,7.2,16.9,10.15,10.15,0,0,0,7.2-3l.3-.3A9.94,9.94,0,0,0,349,258.4Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                    <path\n                      d="M322.6,282.3a10,10,0,0,0-13.6-3.9A110.06,110.06,0,0,1,155.8,136.5a10,10,0,1,0-18.2-8.2A130.05,130.05,0,0,0,318.7,296,10.12,10.12,0,0,0,322.6,282.3Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                    <path\n                      d="M175,92.9a10,10,0,0,0-14.1.5l-.2.2a10,10,0,0,0,7.3,16.8,9.85,9.85,0,0,0,7.3-3.2l.2-.2A10,10,0,0,0,175,92.9Z"\n                      transform="translate(-29.96)"\n                      fill="#997c00"\n                    />\n                  </svg>') + '\n            </div>\n            <div>\n              ' + (award.awardName ? '<span>' + award.awardName + '</span>' : '') + '\n              ' + (award.body ? '<span>' + award.body + '</span>' : '') + '\n            </div>\n          </li>\n        ';

                  html = '<ul class="accordion__awards-list">' + awardsHtml + '</ul>';
                  if (awardsAccordionContainer) {
                    awardsAccordionContainer.innerHTML = html;
                  }
                });
              } else {
                awardsAccordionEl = document.querySelector('.js-accordion');


                if (awardsAccordionEl) {
                  awardsAccordionEl.classList.add('hide');
                }
              }

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  onUnload: function onUnload() {
    this.productForm.destroy();
    this.removeEventListener('click', this.onThumbnailClick);
    this.removeEventListener('keyup', this.onThumbnailKeyup);
  },
  getProductJson: function getProductJson(handle) {
    return fetch('/products/' + handle + '.js').then(function (response) {
      return response.json();
    });
  },
  onFormOptionChange: function onFormOptionChange(event) {
    var variant = event.dataset.variant;

    this.renderImages(variant);
    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);

    this.updateBrowserHistory(variant);
  },
  handleQuantitySelector: function handleQuantitySelector(event) {
    event.preventDefault();
    var target = event.target;
    var actionType = target.dataset.quantitySelector;
    var qtyInput = this.container.querySelector('[data-quantity-input]');
    var qtyInputValue = Number(qtyInput.value);

    if (actionType === 'minus') {
      qtyInputValue -= 1;

      if (qtyInputValue < 1) qtyInputValue = 1;
    } else {
      qtyInputValue += 1;
    }

    qtyInput.value = qtyInputValue;
  },
  onThumbnailClick: function onThumbnailClick(event) {
    var thumbnail = event.target.closest(selectors.thumbnail);

    if (!thumbnail) {
      return;
    }

    event.preventDefault();

    this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },
  onThumbnailKeyup: function onThumbnailKeyup(event) {
    if (event.keyCode !== keyboardKeys.ENTER || !event.target.closest(selectors.thumbnail)) {
      return;
    }

    var visibleFeaturedImageWrapper = this.container.querySelector(selectors.visibleImageWrapper);

    (0, _themeA11y.forceFocus)(visibleFeaturedImageWrapper);
  },
  renderSubmitButton: function renderSubmitButton(variant) {
    var submitButton = this.container.querySelector(selectors.submitButton);
    var submitButtonText = this.container.querySelector(selectors.submitButtonText);

    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
    }
  },
  renderImages: function renderImages(variant) {
    if (!variant || variant.featured_image === null) {
      return;
    }

    this.renderFeaturedImage(variant.featured_image.id);
    this.renderActiveThumbnail(variant.featured_image.id);
  },
  renderPrice: function renderPrice(variant) {
    var priceElement = this.container.querySelector(selectors.productPrice);
    var priceWrapperElement = this.container.querySelector(selectors.priceWrapper);

    priceWrapperElement.classList.toggle(classes.hide, !variant);

    if (variant) {
      priceElement.innerText = (0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat);
    }
  },
  renderComparePrice: function renderComparePrice(variant) {
    if (!variant) {
      return;
    }

    var comparePriceElement = this.container.querySelector(selectors.comparePrice);
    var compareTextElement = this.container.querySelector(selectors.comparePriceText);

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    if (variant.compare_at_price > variant.price) {
      comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = '';
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },
  renderActiveThumbnail: function renderActiveThumbnail(id) {
    var activeThumbnail = this.container.querySelector(selectors.thumbnailById(id));
    var inactiveThumbnail = this.container.querySelector(selectors.thumbnailActive);

    if (activeThumbnail === inactiveThumbnail) {
      return;
    }

    inactiveThumbnail.removeAttribute('aria-current');
    activeThumbnail.setAttribute('aria-current', true);
  },
  renderFeaturedImage: function renderFeaturedImage(id) {
    var activeImage = this.container.querySelector(selectors.visibleImageWrapper);
    var inactiveImage = this.container.querySelector(selectors.imageWrapperById(id));

    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  },
  updateBrowserHistory: function updateBrowserHistory(variant) {
    var enableHistoryState = this.productForm.element.dataset.enableHistoryState;

    if (!variant || enableHistoryState !== 'true') {
      return;
    }

    var url = (0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }
});